export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-underline-427ade6e04d34352d1985e0f38fd771b.svg";